/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { getUrlSync, IActionContext } from '@msdyn365-commerce/core';

/**
 * Retrieves the url for order history page.
 * @param actionContext - Core action context.
 * @returns Url to order History.
 */
export const getOrderHistoryPageUrl = (actionContext: IActionContext): string => {
    return getUrlSync('orders', actionContext) || '';
};
